import React, { useState, useEffect, useMemo } from "react";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import actions from "../../smartCharts/actions";
import { showAlert } from "../../../config/utils";

export const ExportPopup = ({ projectId, clientId, onDownload, onCancel, isExporting }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (projectId && clientId) {
            dispatch(actions.getExportTemplateListForSmartChartRecom({ project_id: projectId, client_id: clientId }));
        }
    }, [dispatch, projectId, clientId]);

    const exportTemplates = useSelector(state => state.smartChartReducer?.exportTemplateList || {});
    const { without_client = [], with_client = [] } = exportTemplates;

    const groupedOptions = useMemo(() => {
        const master = without_client.map(tpl => ({ value: tpl.id, label: tpl.name }));
        const local = with_client.map(tpl => ({ value: tpl.id, label: tpl.name }));
        return [
            { label: "From Local", options: local },
            { label: "From Master", options: master }
        ];
    }, [without_client, with_client]);

    const [recomTemplate, setRecomTemplate] = useState(null);

    const [fileType, setFileType] = useState("excel");
    const [showSettings, setShowSettings] = useState(true);
    const [showSettingsPercentage, setShowSettingsPercentage] = useState(true);
    const [showSettingsAmount, setShowSettingsAmount] = useState(true);
    const [showActual, setShowActual] = useState(true);
    const [showActualPercentage, setShowActualPercentage] = useState(true);
    const [showActualAmount, setShowActualAmount] = useState(true);

    const handleDownload = () => {
        const noSettings = !showSettings || (!showSettingsPercentage && !showSettingsAmount);
        const noActual = !showActual || (!showActualPercentage && !showActualAmount);
        if (noSettings && noActual) {
            showAlert("Please select at least one column to export.");
            return;
        }
        const payload = {
            template_id: recomTemplate?.value,
            show_columns: {
                Setting: { percentage: showSettings && showSettingsPercentage, value: showSettings && showSettingsAmount },
                Actual: { percentage: showActual && showActualPercentage, value: showActual && showActualAmount }
            }
        };
        onDownload(payload, fileType);
    };

    return (
        <div className="modal modal-region add-image-modal img-pop-small" style={{ display: "block" }} tabIndex={-1}>
            <Draggable handle=".draggable" cancel=".not-draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body region-otr draggable">
                            <div className="close-btn-area not-draggable">
                                <button type="button" className="close" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="Close" />
                                    </span>
                                </button>
                            </div>
                            <h3 className="m-0">Soft cost Export</h3>

                            <div className="card content-area mt-2 not-draggable p-0">
                                <div className="card-body pb-0">
                                    <div className="radio-area">
                                        <div className="heading">
                                            <h3>Export Template (Optional)</h3>
                                        </div>
                                        <div className="radio-sec">
                                            <div className="p-2">
                                                <ReactSelect
                                                    options={groupedOptions}
                                                    value={recomTemplate}
                                                    onChange={setRecomTemplate}
                                                    isClearable
                                                    isSearchable={false}
                                                    classNamePrefix="react-select"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="radio-area">
                                        <div className="heading">
                                            <h3>Please Select File Type</h3>
                                        </div>
                                        <div className="radio-sec">
                                            <div className="button-group">
                                                <div className="button">
                                                    <label className="container cursor-hand">
                                                        <input
                                                            type="radio"
                                                            name="fileType"
                                                            value="excel"
                                                            checked={fileType === "excel"}
                                                            onChange={() => setFileType("excel")}
                                                        />
                                                        <span className="checkmark" /> Excel
                                                    </label>
                                                </div>
                                                <div className="button">
                                                    <label className="container cursor-hand">
                                                        <input
                                                            type="radio"
                                                            name="fileType"
                                                            value="word"
                                                            checked={fileType === "word"}
                                                            onChange={() => setFileType("word")}
                                                        />
                                                        <span className="checkmark" /> Word
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="radio-area">
                                        <div className="heading">
                                            <h3>Show Settings Column</h3>
                                        </div>
                                        <div className="radio-sec">
                                            <div className="button-group">
                                                <div className="button">
                                                    <label className="container cursor-hand">
                                                        <input
                                                            type="radio"
                                                            name="showSettings"
                                                            value="true"
                                                            checked={showSettings}
                                                            onChange={() => setShowSettings(true)}
                                                        />
                                                        <span className="checkmark" /> Yes
                                                    </label>
                                                </div>
                                                <div className="button">
                                                    <label className="container cursor-hand">
                                                        <input
                                                            type="radio"
                                                            name="showSettings"
                                                            value="false"
                                                            checked={!showSettings}
                                                            onChange={() => setShowSettings(false)}
                                                        />
                                                        <span className="checkmark" /> No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {showSettings && (
                                            <div className="radio-sec">
                                                <div className="button-group">
                                                    <div className="button">
                                                        <label className="container cursor-hand">
                                                            <input
                                                                type="checkbox"
                                                                name="showSettingsPercentage"
                                                                value="true"
                                                                checked={showSettingsPercentage}
                                                                onChange={() => setShowSettingsPercentage(!showSettingsPercentage)}
                                                            />
                                                            <span className="checkmark" /> Show Percentage
                                                        </label>
                                                    </div>
                                                    <div className="button">
                                                        <label className="container cursor-hand">
                                                            <input
                                                                type="checkbox"
                                                                name="showSettingsAmount"
                                                                value="false"
                                                                checked={showSettingsAmount}
                                                                onChange={() => setShowSettingsAmount(!showSettingsAmount)}
                                                            />
                                                            <span className="checkmark" /> Show Amount
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="radio-area">
                                        <div className="heading">
                                            <h3>Show Actual Column</h3>
                                        </div>
                                        <div className="radio-sec">
                                            <div className="button-group">
                                                <div className="button">
                                                    <label className="container cursor-hand">
                                                        <input
                                                            type="radio"
                                                            name="showActual"
                                                            value="true"
                                                            checked={showActual}
                                                            onChange={() => setShowActual(true)}
                                                        />
                                                        <span className="checkmark" /> Yes
                                                    </label>
                                                </div>
                                                <div className="button">
                                                    <label className="container cursor-hand">
                                                        <input
                                                            type="radio"
                                                            name="showActual"
                                                            value="false"
                                                            checked={!showActual}
                                                            onChange={() => setShowActual(false)}
                                                        />
                                                        <span className="checkmark" /> No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {showActual && (
                                            <div className="radio-sec">
                                                <div className="button-group">
                                                    <div className="button">
                                                        <label className="container cursor-hand">
                                                            <input
                                                                type="checkbox"
                                                                name="showActualPercentage"
                                                                value="true"
                                                                checked={showActualPercentage}
                                                                onChange={() => setShowActualPercentage(!showActualPercentage)}
                                                            />
                                                            <span className="checkmark" /> Show Percentage
                                                        </label>
                                                    </div>
                                                    <div className="button">
                                                        <label className="container cursor-hand">
                                                            <input
                                                                type="checkbox"
                                                                name="showActualAmount"
                                                                value="false"
                                                                checked={showActualAmount}
                                                                onChange={() => setShowActualAmount(!showActualAmount)}
                                                            />
                                                            <span className="checkmark" /> Show Amount
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="down-area mt-0">
                                    <button className="btn btn-download" onClick={handleDownload}>
                                        Download
                                        {isExporting && <span className="spinner-border spinner-border-sm pl-2 ml-1" role="status"></span>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};
